import { useSyncExternalStore } from 'react';

// Memory only: a draft survives expanding/minimizing, without storing screenshots on disk.
const drafts = new Map();
const listeners = new Set();
const empty = { text: '', images: [] };
const subscribe = (fn) => { listeners.add(fn); return () => listeners.delete(fn); };
export function useAssistantDraft(owner) {
  const key = owner || 'signed-out';
  const state = useSyncExternalStore(subscribe, () => drafts.get(key) || empty);
  const set = (field, value) => {
    const current = drafts.get(key) || empty;
    drafts.set(key, { ...current, [field]: typeof value === 'function' ? value(current[field]) : value });
    listeners.forEach((fn) => fn());
  };
  return [state.text, (value) => set('text', value), state.images, (value) => set('images', value)];
}
